export function mapBody(body) {
  return {
    ...body,
    recordType: 'fastcounter',
    marketCodes: body.config.previewData.markets.selected
  }
}
